export default __webpack_public_path__ + "static/media/config_1.454b87bf.png";